/* @flow */
import React from 'react';
import { Button, buttonTypes, buttonSizes } from 'moods-react/Button';
import { IconUiCloseXbold } from 'moods-react/Icons';
import ImageLoader from '../image-loader/ImageLoaderComponent';

import './Dialog.scss';

type Props = {
  thumbnailImageUrl: string,
  thumbnailAltText: string,
  title: string,
  description: string,
  children: any,
  actions: { closeOverlay: Function },
};

class DialogComponent extends React.Component<Props> {
  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  handleOutsideClick = (e: Event): void => {
    // Can't use ref because of IE11 bug
    const node = document.querySelector('.dialog-component'); // eslint-disable-line compat/compat
    if (node && node.contains((e.target: any))) {
      return;
    }

    this.props.closeOverlay();
  };

  render() {
    return (
      <div className="dialog-component u-boxShadow-offsetSmall">
        {this.props.thumbnailImageUrl && (
          <div className="dialog-component__thumbnail-container" data-dialog-thumbnail>
            <div className="dialog-component__thumbnail">
              <ImageLoader image={this.props.thumbnailImageUrl} altText={this.props.thumbnailAltText} />
            </div>
          </div>
        )}
        <Button
          isDisc
          type={buttonTypes.TRANSPARENT_DARK}
          icon={IconUiCloseXbold}
          size={buttonSizes.SMALL}
          className="dialog-component__close-button"
          onClick={this.props.closeOverlay}
        />
        <h3 className="dialog-component__header" data-dialog-header>
          {this.props.title}
        </h3>
        {this.props.description && (
          <p className="dialog-component__description u-fontSize-m">{this.props.description}</p>
        )}
        <div className="dialog-component__body">{this.props.children}</div>
      </div>
    );
  }
}

DialogComponent.displayName = 'Dialog';

export default DialogComponent;
